import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link, NavLink } from "react-router-dom";
import AddExpensePage from "./pages/AddExpensePage";
import ListExpensePage from "./pages/ListExpensePage";
import CalculationPage from "./pages/CalculationPage";
import './App.css';
import Navbar from "./Navbar";

function App() {
    const [expenses, setExpenses] = useState(() => {
        const storedExpenses = localStorage.getItem('expenses');
        return storedExpenses ? JSON.parse(storedExpenses) : [];
      });
      
      useEffect(() => {
        localStorage.setItem('expenses', JSON.stringify(expenses));
      }, [expenses]);
      
      const addExpense = (expense) => {
        setExpenses((prevExpenses) => [...prevExpenses, expense]);
      };
      
      const deleteExpense = (index) => {
        setExpenses(expenses.filter((_, i) => i !== index));
      };
    return (
        <Router>
            {<nav className="navbar">
                <ul className="navbar-list">
                    <li className="navbar-item">
                        <NavLink to="/" className="navbar-link" style={({ isActive }) => ({ background: isActive ? '#aa990e' : '' })}>Expense List</NavLink>
                    </li>
                    <li className="navbar-item">
                        <NavLink to="/add" className="navbar-link" style={({ isActive }) => ({ background: isActive ? '#aa990e' : '' })}>Add Expense</NavLink>
                    </li>
                </ul>
            </nav>}


            <Routes>
                <Route path="/" element={<ListExpensePage expenses={expenses} deleteExpense={deleteExpense} />} />
                <Route path="/add" element={<AddExpensePage addExpense={addExpense} />} />
                <Route path="/calculate" element={<CalculationPage expenses={expenses} />} />
            </Routes>
        </Router>
    );
}

export default App;